// Simple text-to-emoji conversion for common patterns
// Converts only when user presses space after pattern

const SIMPLE_EMOJI_MAP: Record<string, string> = {
  // Basic faces - most common
  ':)': '😊',
  ':(': '😢', 
  ':D': '😀',
  ';)': '😉',
  ':P': '😜',
  ':p': '😜',
  // Hearts
  '<3': '❤️',
  // Party
  '\\o/': '🙌',
  // Cool
  '8)': '😎',
  // Surprised  
  ':O': '😮',
  ':o': '😮'
};

/**
 * Convert last word to emoji if it matches a pattern
 * @param text Current text content
 * @returns Text with last word converted to emoji if matched
 */
export function convertLastWordToEmoji(text: string): string {
  const words = text.split(' ');
  const lastWord = words[words.length - 1];
  
  if (lastWord && SIMPLE_EMOJI_MAP[lastWord]) {
    words[words.length - 1] = SIMPLE_EMOJI_MAP[lastWord];
    return words.join(' ');
  }
  
  return text;
}